import React from 'react';
import GenericColorPicker from '../../components/common/colorpicker/GenericColorPicker';

const GenericColorPickerComponent = (props) => (
  <GenericColorPicker {...props} />
);

export default GenericColorPickerComponent;
